/* -------------------------------------------------------------------------- */
/*                           Internationalization I18n                        */
/* -------------------------------------------------------------------------- */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './en/translations.json';
import translationFR from './fr/translations.json';

i18n.use(initReactI18next).init({
	lng: 'fr',
	debug: false,
	resources: {
		en: {
			translation: translationEN,
		},
		fr: {
			translation: translationFR,
		},
	},
});

export default i18n;
